import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { useAddPayment } from '@features/payment/hooks/useAddPayment'
import { useManagePaymentMethods } from '@features/payment/hooks/useManagePaymentMethods'

import { PAYMENT_TYPE_HALYK, PaymentPluginId } from '@shared/contants'
import Wrapper from '@shared/ui/wrapper'

import CardItem from './card-item/CardItem.tsx'
import Loader from './loader/Loader'
import { PaymentVerifier } from './payment-verifier/PaymentVerifier.tsx'

import styles from './styles.module.scss'


export default function PaymentMethods () {
  const { t } = useTranslation('personal')
  const { t: tp } = useTranslation('payment')

  const { paymentMethods, loading: isLoadingMethods } =
    useManagePaymentMethods()
  const { addPayment } = useAddPayment()

  const isLoading = isLoadingMethods

  const handlePaymentTypeSelect = async (paymentPluginId: PaymentPluginId) => {
    await addPayment(paymentPluginId)
    // redirect происходит в useAddPayment
  }

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.root}>
      <Wrapper className={styles.root__wrapper}>
        <PaymentVerifier />
        <h2 className={styles.root__title}>{t('nav.payment')}</h2>
        {paymentMethods.length > 0 && (
          <div className={styles.root__cards}>
            {paymentMethods
              .filter((el) => el !== null)
              .map((el) => (
                <CardItem key={el.id} data={el} />
              ))}
          </div>
        )}

        <div className={styles.root__addButtons}>
          <button
            onClick={() => handlePaymentTypeSelect(PAYMENT_TYPE_HALYK)}
            className={styles.root__addButton}
          >
            <ReactSVG wrapper="span" src="/icons/card.svg" className={styles.root__addButtonIcon} />
            <span>{tp('card.bind_button')}</span>
          </button>
        </div>
      </Wrapper>
    </div>
  )
}
